// Vendors
import React from 'react';

// Helpers
import { tablefy } from '../../../components/helpers';

const Appliances = ({ projectData, openAccordion, handleToggleAccordion }) => (
  <div className="grid__col-xs-12 u--margin-bottom-20">
    <button
      className={`btn btn--white btn--block btn--lg btn--pip-accordion btn--has-arrow module-hover-root ${
        openAccordion['appliances'] === true ? 'btn--pip-accordion--on' : ''
      }`}
      type="button"
      onClick={() => handleToggleAccordion('appliances')}
    >
      <span className="btn__content u--display-flex u--align-items-center u--justify-content-space-between u--padding-left-20 u--padding-right-20 u--padding-top-5 u--padding-bottom-5 u--height-auto">
        <span className="btn__text">Appliances</span>
        <span className="btn__arrow"></span>
      </span>
    </button>
    <div
      className={
        openAccordion['appliances'] === true
          ? 'u--display-block u--padding-top-20 u--squash-end u--padding-bottom-10'
          : 'u--display-none'
      }
    >
      <strong>Base Appliances:</strong>
      {tablefy(
        {
          'Boiler:': projectData.appliance_boiler,
          'Furnace:': projectData.appliance_furnace,
          'Hydronic Air Handler:': projectData.appliance_hydronic_air_handler,
          'Combi Boiler:': projectData.appliance_combi_boiler,
          'Water Heater:': projectData.appliance_water_heater,
          'Hybrid Heat Pump:': projectData.appliance_hybrid_heat_pump
        },
        true
      )}
      <strong className="u--display-block u--margin-top-30">
        Additional Appliances:
      </strong>
      {tablefy(
        {
          'Cooktop or range:': projectData.appliance_cooktop_range,
          'Cooktop or range changed from...':
            projectData.appliance_cooktop_range_changed_from,
          'Oven:': projectData.appliance_oven,
          'Oven changed from...': projectData.appliance_oven_changed_from,
          'Grill:': projectData.appliance_grill,
          'Clothes dryer:': projectData.appliance_clothes_dryer,
          'Clothes dryer changed from...':
            projectData.appliance_clothes_dryer_changed_from,
          'Standby Generator:': projectData.appliance_standby_generator,
          'Standby Generator changed from...':
            projectData.appliance_standby_generator_changed_from,
          'Fireplace/Gas Log Set:': projectData.appliance_fireplace_gas_log,
          'Fireplace/Gas Log Set changed from...':
            projectData.appliance_fireplace_gas_log_changed_from,
          'Piping propane gas:': projectData.appliance_piping_propane_gas,
          'Piping propane gas changed from...':
            projectData.appliance_piping_propane_gas_changed_from
        },
        true
      )}
    </div>
  </div>
);
export default Appliances;
